// @flow
import { Grid } from 'semantic-ui-react';
import React, { useContext } from 'react';

import { SelectField } from '../../../formik-utils/FormFields';
import { getDropdownOptions } from '../../stream-governance/utils';
import { EstimateCommittedCapacityMetadataContext } from '../../../contexts/EstimateCommittedCapacityMetadataContext';
import { ESTIMATE_COMMITTED_CAPACITY } from '../enums';
import {
  getDimensionFieldPathForEstimateCC,
  getIfGivenRowIsANewlyAddedRowForEstimateCC,
} from '../utils';

export const TableflowDimensionColumnsForEstimateCC = ({ metricIndex, dimensionIndex, row }) => {
  const providerPath = getDimensionFieldPathForEstimateCC(
    metricIndex,
    dimensionIndex,
    ESTIMATE_COMMITTED_CAPACITY.PROVIDER_BACKEND_FIELD_NAME
  );

  const providerColConfig = {
    backendFieldName: ESTIMATE_COMMITTED_CAPACITY.PROVIDER_BACKEND_FIELD_NAME,
    displayNameCol: ESTIMATE_COMMITTED_CAPACITY.PROVIDER_LABEL_DISPLAY_NAME_COL,
    parentFieldsInGroup: [],
  };

  const metaDataContextData = useContext(EstimateCommittedCapacityMetadataContext);
  const dataUniverse = metaDataContextData?.committed_tableflow_capacity_configs ?? [];

  const providerDropDownOptions = getDropdownOptions(
    dataUniverse,
    row,
    providerColConfig,
    false,
    false,
    false,
    true
  );

  const shouldColumnBeDisabled = !getIfGivenRowIsANewlyAddedRowForEstimateCC(row);

  return (
    <Grid.Column width={3}>
      <SelectField
        addLabel={false}
        disableOnFormErrors={false}
        disabled={shouldColumnBeDisabled}
        fieldDisplayName={ESTIMATE_COMMITTED_CAPACITY.PROVIDER_DISPLAY_NAME}
        fieldName={providerPath}
        options={providerDropDownOptions}
      />
    </Grid.Column>
  );
};
